import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import actions from '@flux/action';
import { API } from '@service';

const useWidget = (_widgetId) => {
  const dispatch = useDispatch();
  const [widgetId, setWidgetId] = useState(_widgetId);
  const [privateData, setPrivateData] = useState();
  const [isLoading, toggleLoading] = useState(false);
  const projectId = useSelector((state) => state.common.currentId);
  const widgetStore = useSelector((state) => state.projects.widgets);
  const widgetList = useMemo(() => Object.keys(widgetStore), [widgetStore]);

  const widgetData = widgetId ? widgetStore[widgetId] : privateData;

  const setWidget = (data, hasId = widgetId) => {
    if (hasId) {
      dispatch(actions.changeWidget({ widgetId, data }));
      return;
    }
    setPrivateData(data);
  };

  const deleteWidget = () => {
    dispatch(actions.deleteWidget(widgetId));
  };

  const saveWidget = async (data) => {
    toggleLoading(true);
    const newData = Object.assign({}, widgetData, data);
    const result = await API.saveCustomzizedWidget(
      projectId,
      widgetId,
      newData,
    );
    if (result.message === 'save chart successfully') {
      setWidgetId(result.id);
      newData.data = result.data;
      setWidget(newData, result.id);
    }
    toggleLoading(false);
    return result.id;
  };

  // console.log({ widgetId, widgetData });

  const asyncRemote = async () => {
    toggleLoading(true);
    const { sucess, widgetInfo } =
      (await API.getCustomizedWidget(widgetId)) || {};

    //TODO: ?data is a string? remove these code after fix of backend;
    if (typeof widgetInfo.data === 'string') {
      try {
        widgetInfo.data = JSON.parse(widgetInfo.data);
      } catch (e) {
        //do nothing
      }
    }
    if (!sucess) {
      dispatch(actions.changeWidget({ widgetId, data: null }));
      return;
    }
    dispatch(actions.changeWidget({ widgetId, data: widgetInfo }));
    toggleLoading(false);
  };

  useEffect(() => {
    if (widgetId) {
      asyncRemote();
    }
  }, [widgetId]);

  return {
    //common params and func
    widgetId,
    widgetData,
    isLoading,
    setWidget,
    saveWidget,

    //Optional params and func, declear if you need
    widgetList,
    widgetStore,
    deleteWidget,
  };
};

export default useWidget;

//@example runable script
// const mockId = '202071CE-C4BC-45B5-9B49-2DE90B6FC2F1';
// const mockData = {
//   moduleId: '-yAkXjetI4NO3diVfpaAb',
//   moduleType: 'Section',
//   chartType: 'Org Chart',
//   data: [{ L1: '2014', L2: 'Products', Value: '$100', Comments: '' }],
// };

// const { widgetData, setWidget, saveWidget } = useWidget(mockId);

// useEffect(() => {
//   testLog([mockId, widgetData]);
// }, [widgetData]);
